import { nowTs } from '@mi-front/core';
import debugFn from 'debug';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
import { useStreamSegmentsRange } from '../segments/useStreamSegmentsQuery';

const debug = debugFn('logger:useRangeIsLatest');

const OUTDATED_THRESHOLD = 120000;

export function useRangeIsLatest() {
  const range = useStreamSegmentsRange();
  const [isLatest, setIsLatest] = useState(isRangeLatest());

  function isRangeLatest() {
    return nowTs() - range.to < OUTDATED_THRESHOLD;
  }

  useInterval(() => {
    setIsLatest(isRangeLatest());
  }, 10000);

  useEffect(() => {
    debug('range changed, check if latest');
    setIsLatest(isRangeLatest());
  }, [range.from, range.to]);

  return isLatest;
}
